module.exports = __webpack_public_path__ + "media/react/pages/essay_review/illustrated-avatars/4-1a7089a62ff26db08b681ace283f997c.png";